import request from "@/utils/request";

// 登录接口-获取token值
export function login(data) {
    return request({
        url: 'mange/agency/v1.0/login',
        method: 'post',
        data
    })
}


//业务接口-需要传入token
export function gateway(data) {
    return request({
        url: 'mange/agency/v1.0/gateway',
        method: 'post',
        data
    })
}


//业务接口-需要传入token
export function gateway2(data) {
    return request({
        url: 'mange/agency/v1.0/gateway',
        //responseType: "blob",
        method: 'post',
        data
    })
}



// 登录接口-获取token值
export function fireLogin(data) {
    return request({
        url: '/mange/v1.0/fire/login',
        method: 'post',
        data
    })
}


//业务接口-需要传入token
export function fireGateway(data) {
    return request({
        url: '/mange/v1.0/fire/login',
        method: 'post',
        data
    })
}

